module.exports = __webpack_public_path__ + "9b592a4994802d6c7d3c9092cca68ef8.pdf";